import { render, staticRenderFns } from "./VehicleEdit.vue?vue&type=template&id=2d1f1b67&"
import script from "./VehicleEdit.vue?vue&type=script&lang=js&"
export * from "./VehicleEdit.vue?vue&type=script&lang=js&"
import style0 from "./VehicleEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports